import React, { FunctionComponent } from 'react'
import { Language } from '../../types/header.types'
import './LanguageSwitch.scss'

interface LanguageSwitchProps {
  languages: Language[]
}

const LanguageSwitch: FunctionComponent<LanguageSwitchProps> = ({
  languages,
}) => {
  return (
    <div className="LanguageSwitch__container">
      {(languages ?? []).map((lang, i) => (
        <a
          key={i}
          className={lang.selected ? 'LanguageSwitch__active_language' : ''}
          href={lang.href}
        >
          {lang.text.toUpperCase()}
        </a>
      ))}
    </div>
  )
}

export default LanguageSwitch
